import { isQuestionUserMessage } from "@/lib/qualification-lifecycle/metadata-part";
import type { Message } from "@/types";
import type { MessageId } from "@/types/branded";

/** User question message that prompted the given assistant message. */
export function findUserQuestionForAssistantMessage(
  messages: Message[],
  assistantMessageId: MessageId | string
): Message | null {
  const messageIndex = messages.findIndex(
    (message) => String(message.id) === String(assistantMessageId)
  );
  if (messageIndex <= 0) return null;

  for (let index = messageIndex - 1; index >= 0; index -= 1) {
    const message = messages[index];
    if (message && isQuestionUserMessage(message)) {
      return message;
    }
  }

  return null;
}

/** User question id that prompted the given assistant message. */
export function findUserQuestionIdForAssistantMessage(
  messages: Message[],
  assistantMessageId: MessageId | string
): string | null {
  return (
    findUserQuestionForAssistantMessage(messages, assistantMessageId)?.id ??
    null
  );
}

/** User question text that prompted the given assistant message. */
export function findUserQuestionTextForAssistantMessage(
  messages: Message[],
  assistantMessageId: MessageId | string
): string | null {
  const messageIndex = messages.findIndex(
    (message) => String(message.id) === String(assistantMessageId)
  );
  if (messageIndex <= 0) return null;

  for (let index = messageIndex - 1; index >= 0; index -= 1) {
    const message = messages[index];
    if (message && isQuestionUserMessage(message) && message.content.trim()) {
      return message.content.trim();
    }
  }

  return null;
}
